export function remPx() {
    return parseFloat(document.documentElement.style.fontSize.replace("px", ""));
}

export function merge(a: any, b: any) {
    for (var prop in b) {
        a[prop] = b[prop];
    }
}

export function listProperties(o: any): string[] {
    let result = [];

    for (var prop in o) {
        result.push(prop);
    }

    return result;
}

export interface Dictionary<T> {
    [prop: string]: T;
}

export function toDictionary<T, TVal>(array: T[], keySelector: ((x: T) => string), valueSelector: ((x: T) => TVal)): Dictionary<TVal> {
    let result = <Dictionary<TVal>> {};

    for (let x of array) {
        let key = keySelector(x);
        result[key] = valueSelector(x);
    }

    return result;
}

export function regexMatch(regex: RegExp, str: string, pos: number): string|null {
    let match = regex.exec(str.substr(pos));
    if (match == null) return null;

    return match[0];
}

export function generateId(): string {
    while(true) {
        let str = randomString();
        let x = document.getElementById(str);
        if (x == null) return str;
    }
}

function randomString(): string {
    return (Math.round(Math.random() * 65535 + 1)).toString(36);
}

export function isEnterPressed(event: KeyboardEvent) {
    if (event.keyCode === 13)
        return true;

    return event.key === 'ENTER';
}

export function isSpacePressed(event: KeyboardEvent) {
    if (event.keyCode === 32)
        return true;

    return event.key === ' ';
}

export function removeElement(e: HTMLElement|null) {
    if (e?.parentElement != null) {
        e.parentElement.removeChild(e);
    }
}

export function elementOffset(element: HTMLElement) {
    if (!element.getClientRects().length)
        return { top: 0, left: 0 };

    let rect = element.getBoundingClientRect();
    let window = element.ownerDocument.defaultView;
    if (window === null)
        throw "No window found";

    return {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset
    }
}

/* Randomize array in-place using Durstenfeld shuffle algorithm */
export function shuffleArray<T>(array: T[]): void {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}

export function arrayIsEqual(array: any[], contains: any[]): boolean {
    return array.length >= contains.length && contains.every((c, i) => array[i] === c);
}

export function arrayContains(array: any[], contains: any[]): boolean {
    return array.length >= contains.length && contains.every(c => array.indexOf(c) > -1);
}

export function shallowCopy<T extends Object>(obj: T): T;
export function shallowCopy<T extends Object>(obj: T|null): T | null;
export function shallowCopy<T extends Object>(obj: T|null): T | null {
    if (obj == null)
        return null;
    let result: any = {};
    for (let x in obj) {
        if (obj.hasOwnProperty(x))
            result[x] = obj[x];
    }

    return result;
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}